import script from "./AppPopupInvitation.vue?vue&type=script&lang=ts"
export * from "./AppPopupInvitation.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__